import styled from "styled-components";
import { mobileOnly } from "_/style/media";
import { Link } from "_/components/router";

export const MachineListWrapper = styled.div`
  position: relative; /* anchor for the button */
`;

export const MachineList = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 3rem;
  row-gap: 0.5rem;
  padding-right: 6rem; /* keep content clear of the button */
`;

export const MachineLink = styled(Link)`
  white-space: nowrap;
  &:hover {
    text-decoration: underline;
  }
`;

export const ToggleLink = styled.a`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;

  color: ${(p) => p.theme.color.brand.blue};
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
  ${mobileOnly`
    position: relative;
  `}
`;
